import React from 'react';

import Loading from 'components/Loading';
import getVisibleFateCards from 'selectors/fate/getVisibleFateCards';
import { FateData } from 'types/fate';

import FateCard from './components/FateCard';
import Header from './components/Header';

type Props = {
  data: FateData,
  fateCards: ReturnType<typeof getVisibleFateCards>,
  onClickBuyFateButton: () => void,
};

export default function FateComponent(props: Props) {
  const {
    data,
    fateCards,
    onClickBuyFateButton,
  } = props;

  if (!data.premiumSubPurchaseCard) {
    return <Loading />;
  }

  return (
    <div>
      <div className="fate-header">
        <div className="fate-header__text">
          <h1 className="heading heading--1">
            {`You have ${data.currentFate} Fate Points`}
          </h1>
          <p className="col-2-of-3 lede">Buy Fate to get premium content, extra storylines or faster progression.</p>
        </div>
        <button
          className="button button--secondary fate-header__button"
          onClick={onClickBuyFateButton}
          type="button"
        >
          Buy fate
        </button>
      </div>
      <Header data={data} />
      <hr />
      {fateCards.map(item => (
        <FateCard
          key={item.id}
          data={item}
        />
      ))}
    </div>
  );
}

/*
FateComponent.propTypes = {
  data: FatePropTypes.fateData.isRequired,
  fateCards: PropTypes.arrayOf(FatePropTypes.fateCard).isRequired,
  onClickBuyFateButton: PropTypes.func.isRequired,
};
 */